module.exports = __webpack_public_path__ + "static/media/payu-dark.80265cc7.svg";